export default __webpack_public_path__ + "static/media/team6.ef45630b.png";